import { get, writable } from 'svelte/store';
import { Role } from '../types';
import { Poller } from '../common/poller';
import { deepCompare } from './util';
import { v4 } from 'uuid';
export class MySessionStore {
    constructor(walker, paths, locale, sessionRemoteRepository, tokenSessionStorageRepository, tokenRemoteRepository, conversationStore) {
        this.walker = walker;
        this.paths = paths;
        this.locale = locale;
        this.sessionRemoteRepository = sessionRemoteRepository;
        this.tokenSessionStorageRepository = tokenSessionStorageRepository;
        this.tokenRemoteRepository = tokenRemoteRepository;
        this.conversationStore = conversationStore;
        this.store = writable(this.getSessionFromJwtPayload() || this.createAnonymousSession());
        this.poller = new Poller(() => this.poll());
        this.subscribe = this.store.subscribe;
        this.poller.start();
    }
    async loginClient(credentials) {
        this.tokenRemoteRepository.deleteToken();
        const jwtPayload = await this.tokenRemoteRepository.createClientUserToken(credentials, get(this.locale));
        const session = await this.sessionRemoteRepository.fetchSession(jwtPayload.session_id);
        this.store.set(session);
        const conversation = await this.conversationStore.createConversation(session);
        await this.walker.goTo(get(this.paths).conversation(conversation));
    }
    async loginOperator(credentials) {
        this.tokenRemoteRepository.deleteToken();
        const jwtPayload = await this.tokenRemoteRepository.createRegisteredUserToken(credentials, get(this.locale));
        const session = await this.sessionRemoteRepository.fetchSession(jwtPayload.session_id);
        this.store.set(session);
    }
    async logout() {
        const current = get(this.store);
        if (!current.roles.includes(Role.ANONYMOUS)) {
            try {
                await this.sessionRemoteRepository.endSession(current);
            }
            catch (e) {
                console.log('Exception while ending session', current);
            }
        }
        this.tokenRemoteRepository.deleteToken();
        let newSession = this.createAnonymousSession();
        this.store.set(newSession);
    }
    sendCloseBeacon() {
        const current = get(this.store);
        if (!current.roles.includes(Role.ANONYMOUS)) {
            this.sessionRemoteRepository.sendCloseBeacon(current);
        }
    }
    async poll() {
        const current = get(this.store);
        if (!current.roles.includes(Role.ANONYMOUS)) {
            const newSession = await this.sessionRemoteRepository.fetchSessionLiveness(current.id);
            if (newSession.endDate) {
                await this.logout();
                return;
            }
            else if (!deepCompare(newSession, current)) {
                this.store.set(newSession);
            }
        }
    }
    getSessionFromJwtPayload() {
        const jwtPayload = this.tokenSessionStorageRepository.getJwtPayload();
        if (jwtPayload) {
            return {
                id: jwtPayload.session_id,
                roles: jwtPayload.scope,
                username: '-',
                locale: '-',
                createDate: new Date(),
            };
        }
        return null;
    }
    createAnonymousSession() {
        return {
            id: v4(),
            username: '-',
            locale: get(this.locale) || '-',
            roles: [Role.ANONYMOUS],
            createDate: new Date(),
        };
    }
}
